import ConfigurationComponent from './Configuration';

export const Configuration = ConfigurationComponent;